export default __webpack_public_path__ + "static/media/WhatsApp Image 2024-02-19 at 3.00.08 PM (1).97ff484a.jpeg";